import AmenitiesSelect from './AmenitiesSelect';

export default AmenitiesSelect;
